<template>
  <div v-if="loanEndDate" v-html="remainingTime" class="u-tac"></div>
</template>

<script>
export default {
  props: {
    loanEndDate: {
      type: String,
      default: null
    }
  },

  computed: {
    remainingTime () {
      let remaining = new Date(this.loanEndDate).getTime() - new Date().getTime()
      let rawDays = remaining / (24 * 60 * 60 * 1000)
      let days = Math.floor(rawDays)
      let hours = Math.floor((rawDays % 1) * 24)

      if (days === 0 && hours === 0) {
        return this.$i18n.t('no_remaining_time_for_loan')
      }

      let units = this.whichUnit(days, hours)

      return this.$i18n.t('remaining_time_for_loan', { units: units })
    }
  },

  methods: {
    whichUnit (days, hours) {
      if (days === 0) return this.generateUnitString('hour', hours)
      return this.generateUnitString('day', days)
    },

    generateUnitString (unitName, value) {
      return `<strong>${value}&nbsp;${this.$i18n.tc(unitName, value)}</strong>`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RemainingTimeForLoan.vue